import React, { FC, memo, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { LeadsListFilterKeys } from 'pages/UsersPage/model/types';
import { LeadLeaveReason } from 'entities/Lead';

import { Select } from 'shared/ui/Select';
import { DefaultOptionType } from 'antd/es/select';

interface LeadLeaveReasonSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const LeadLeaveReasonSelect: FC<LeadLeaveReasonSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation(['contracts', 'common']);

  const leaveReasonOptions = Object.values(LeadLeaveReason).map((option) => ({
    label: t(option, { ns: 'common' }),
    value: option,
  }));

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(LeadsListFilterKeys.leaveReason);
  }, [onClear]);

  return (
    <Select
      className="w-full"
      label={t('Leave reason')}
      placeholder={t('All')}
      value={value}
      bordered
      allowClear
      options={leaveReasonOptions}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
